import { FC, useCallback, useMemo } from "react";
import { useFlag } from "@unleash/proxy-client-react";
import { Stack } from "@mui/material";
import { useDidMount } from "rooks";
import { useGetUsersMeOrganisationsCurrentFiltersByFilterProviderAndFilterTypeValuesQuery as useValuesQuery } from "@/services/cloudchipr.api";
import { DropdownSelect } from "@/components/common/select/dropdown-select/DropdownSelect";
import { CsvDownloadDialogTriggerComponent } from "@/components/pages/resource-explorer/components/resource-explorer-card/components/billing-explorer-data-grid/components/csv-v2/dialog/dimensions/CsvDownloadDialogTriggerComponent";

interface CsvDownloadDialogDimensionsProps {
  dimensions: string[];
  onDimensionChange(data: string[]): void;
}

export const CsvDownloadDialogDimensions: FC<
  CsvDownloadDialogDimensionsProps
> = ({ dimensions, onDimensionChange }) => {
  const enableCategoryGroupingFilterV2 = useFlag(
    "EnableCategoryGroupingFilterV2",
  );

  const { data, isLoading } = useValuesQuery({
    filterProvider: "dimensions",
    querySource: "resource_explorer",
    filterType: enableCategoryGroupingFilterV2 ? "category" : "dimension_id",
  });

  const options = useMemo(() => {
    if (!data) {
      return [];
    }
    return data?.map((item) => {
      return {
        label: item.title,
        value: item.value,
      };
    });
  }, [data]);

  const dimensionSelectHandler = useCallback(
    (values: string[]) => {
      onDimensionChange(values);
    },
    [onDimensionChange],
  );

  useDidMount(() => {
    const initialSelectedItems = data?.map((item) => item.value) ?? [];
    onDimensionChange(initialSelectedItems);
  });

  return (
    <Stack flex={1}>
      <DropdownSelect
        label="Dimensions"
        values={dimensions}
        options={options}
        submitHandlerOnClose={dimensionSelectHandler}
        disabled={isLoading}
        TriggerComponent={CsvDownloadDialogTriggerComponent}
        listWidth={400}
      />
    </Stack>
  );
};
